module.exports = "/images/Israel.png?4ad5c6122fa3c4386c790bb58c0a2451";